import { render, staticRenderFns } from "./ClaimNoteForm.vue?vue&type=template&id=882d80a6&"
import script from "./ClaimNoteForm.vue?vue&type=script&lang=js&"
export * from "./ClaimNoteForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports